/** Keep six digits without letting pasted spaces consume the code's length. */
export function normalizeEmailCodeInput(event: Event): void {
  const input = event.target;
  if (!(input instanceof HTMLInputElement)) return;
  const value = input.value;
  const normalized = value.replace(/\D/g, '').slice(0, 6);
  if (value === normalized) return;
  const start = value.slice(0, input.selectionStart ?? value.length).replace(/\D/g, '').length;
  const end = value.slice(0, input.selectionEnd ?? value.length).replace(/\D/g, '').length;
  input.value = normalized;
  input.setSelectionRange(Math.min(start, 6), Math.min(end, 6));
}
